import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { UseFormReturn } from "react-hook-form";
import { ReservationFormData } from "@/hooks/useReservationForm";

interface ProductSelectorProps {
  form: UseFormReturn<ReservationFormData>;
  showChateauType: boolean;
  onProductChange: (product: 'sumo' | 'chateau', checked: boolean) => void;
  chateauOptions: Array<{ id: string; name: string }>;
  sumoUnavailable?: boolean;
}

export const ProductSelector = ({ 
  form, 
  showChateauType, 
  onProductChange, 
  chateauOptions,
  sumoUnavailable = false,
}: ProductSelectorProps) => {
  return (
    <div className="space-y-4">
      <Label className="text-base font-semibold">Produit souhaité *</Label>
      
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="sumo" 
            checked={form.watch("products.sumo")}
            onCheckedChange={(checked) => onProductChange('sumo', checked as boolean)}
            disabled={sumoUnavailable}
          />
          <Label htmlFor="sumo" className={`cursor-pointer ${sumoUnavailable ? 'text-muted-foreground line-through' : ''}`}>
            Sumo (50€)
          </Label>
          {sumoUnavailable && (
            <Badge variant="destructive" className="text-xs">Indisponible</Badge>
          )}
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="chateau" 
              checked={form.watch("products.chateau")}
              onCheckedChange={(checked) => onProductChange('chateau', checked as boolean)}
            />
            <Label htmlFor="chateau" className="cursor-pointer">Château Gonflable (à partir de 30€)</Label>
          </div>
          
          {showChateauType && (
            <div className="ml-6">
              <Label htmlFor="chateau-type" className="text-sm">Type de château</Label>
              {chateauOptions.length === 0 ? (
                <p className="text-sm text-destructive mt-1">Aucun château disponible pour ces dates.</p>
              ) : (
                <Select 
                  value={form.watch("chateauType")} 
                  onValueChange={(value) => form.setValue("chateauType", value)}
                >
                  <SelectTrigger className="w-full mt-1 bg-background">
                    <SelectValue placeholder="Choisissez un type de château" />
                  </SelectTrigger>
                  <SelectContent className="bg-background border border-border shadow-lg z-50">
                    {chateauOptions.map((option) => (
                      <SelectItem key={option.id} value={option.id}>
                        {option.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            </div>
          )}
        </div>
      </div>
      {form.formState.errors.products && (
        <p className="text-sm text-destructive mt-1">{form.formState.errors.products.message}</p>
      )}
    </div>
  );
};
